import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import Manual from '../../../../domain/entities/writer/Manual';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterManualsSuccess: {
      const result = action.payload as PaginatedResult<Manual>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
